import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ButtonBase, Typography } from '@material-ui/core';
import { DelaStarIcon } from '~/modules/common/components/Icons';
import useStyles from './useStyles';

export const ResourceMatchItemNoMatches = ({
  dataQeId,
  resourceRequest,
  setAnchorEl,
  setPopoverResourceRequest,
  narrow = false
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const resourceMatchItemNoMatchesDataQeId = dataQeId
    ? `${dataQeId}_ResourceMatchItemNoMatches`
    : undefined;

  const handlePopover = useCallback(
    event => {
      setAnchorEl(event.currentTarget);
      setPopoverResourceRequest(resourceRequest);
    },
    [setAnchorEl, setPopoverResourceRequest, resourceRequest]
  );

  return (
    <div
      data-qe-id={resourceMatchItemNoMatchesDataQeId}
      className={classes.itemRoot}
    >
      <ButtonBase className={classes.itemButton} onClick={handlePopover}>
        <div className={classes.itemInfo}>
          <div className={classes.itemContainer}>
            <div className={classes.itemTextContainer}>
              <DelaStarIcon className={classes.itemDelaStarIcon} />
              {narrow ? (
                <Typography variant="body2" color="textSecondary">
                  {formatMessage({
                    id: 'resourceMatchItem.noMatchesFound'
                  })}
                </Typography>
              ) : (
                <Typography variant="caption" color="textPrimary">
                  {formatMessage({
                    id: 'resourceMatchItem.resourceMatcher'
                  })}
                </Typography>
              )}
            </div>
            {!narrow && (
              <div className={classes.itemTextContainer}>
                <Typography variant="body2" color="textSecondary">
                  {formatMessage({
                    id: 'resourceMatchItem.noMatchesFound'
                  })}
                </Typography>
              </div>
            )}
          </div>
        </div>
      </ButtonBase>
    </div>
  );
};

ResourceMatchItemNoMatches.propTypes = {
  dataQeId: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired,
  setAnchorEl: PropTypes.func.isRequired,
  setPopoverResourceRequest: PropTypes.func.isRequired,
  narrow: PropTypes.bool
};

export default ResourceMatchItemNoMatches;
